import { useMemo, useRef, useState } from 'react';
import './AutocompleteInput.css';

export default function AutocompleteInput({
  value = '',
  onChange,
  suggestions = [],
  placeholder = '',
  disabled = false,
  className = 'sup-input',
  maxItems = 6,
}) {
  const [focused, setFocused] = useState(false);
  const blurTimer = useRef(null);

  const filtered = useMemo(() => {
    const q = (value || '').toLowerCase().trim();
    if (!q) return suggestions.slice(0, maxItems);
    return suggestions
      .filter(s => s && s.toLowerCase().includes(q))
      .slice(0, maxItems);
  }, [value, suggestions, maxItems]);

  const showDrop = focused && filtered.length > 0;

  return (
    <div className="ac-wrap">
      <input
        className={className}
        type="text"
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => {
          clearTimeout(blurTimer.current);
          setFocused(true);
        }}
        onBlur={() => {
          blurTimer.current = setTimeout(() => setFocused(false), 200);
        }}
        autoComplete="off"
      />
      {showDrop && (
        <div className="ac-drop" role="listbox">
          {filtered.map((s) => (
            <div
              key={s}
              className="ac-opt"
              role="option"
              onMouseDown={(e) => {
                e.preventDefault();
                onChange(s);
                setFocused(false);
              }}
            >
              {s}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
